import { machToggleLoadingScreen } from "./main";
import { machAdjustEmailObfuscation } from "./main";

jQuery(document).ready(function () {
    jQuery('#post-filters input[type="checkbox"]').on("change", machHandleFiltersQueryParams);
    jQuery("body").on("click", "#filters-pagination a", machHandleFiltersQueryParams);
    jQuery("#post-filters-form").on("submit", machHandleFiltersQueryParams);
    jQuery(".post-filters-toggle").on("click", machToggleMobileFilters);
});

/**
 * Function called when a filter checkbox changes, a pagination change is requested or when the search input has been submitted.
 * Used to dynamically add the filter params to the URL. We add the filters to the URL to make sure that when a user clicks "back" in his browser, he will keep the filters he was on.
 * When all the filters are in the URL, it triggers the AJAX call to refresh the content based on the URL parameters.
 */
function machHandleFiltersQueryParams(e) {
    // If the browser supports pushState
    if (history.pushState) {
        let search_params = new URLSearchParams(window.location.search);
        let all_filter_names = [];

        //Creates an array of all the  or acf values that can be filtered by parsing the checkboxes
        jQuery('#post-filters input[type="checkbox"]').each(function () {
            if (all_filter_names.indexOf(jQuery(this).data("filter-param")) == -1) {
                all_filter_names.push(jQuery(this).data("filter-param"));
            }
        });

        //Append all selected term IDs for all the taxonomies to the URL
        jQuery.each(all_filter_names, (index, param_name) => {
            let selected_filters = [];

            jQuery('#post-filters input[data-filter-param="' + param_name + '"]:checked').each(function () {
                selected_filters.push(jQuery(this).val());
            });

            if (selected_filters.length > 0) {
                search_params.set(param_name + "_filters", selected_filters.join());
            } else {
                search_params.delete(param_name + "_filters");
            }
        });

        //If the clicked object is a pagination link
        if (jQuery(this).hasClass("page-numbers")) {
            e.preventDefault();
            let pagination_link = jQuery(this).attr("href");
            let page_number_matches = pagination_link.match(/\/page\/(\d*)/);
            //If the regex found matches for a page number
            if (page_number_matches) {
                search_params.set("filter_page", page_number_matches[1]);
            } else {
                //If there's no page number found, remove the page param
                search_params.delete("filter_page");
            }
        } else if (jQuery(this).data("filter-param")) {
            //If it's a filter checkbox has changed, reset the pagination so we go back to the first page
            search_params.delete("filter_page");
        }

        // The new url string
        let new_url = window.location.protocol + "//" + window.location.host + window.location.pathname;
        if (search_params.toString()) {
            new_url += "?" + search_params.toString();
        }
        window.history.pushState({ path: new_url }, "", new_url);

        //Trigger the content refresh
        machRefreshFilteredContent(search_params.toString());
    }

    return false;
}

/**
 * Function making an AJAX request in order to refresh the content based on the filters.
 * @todo: Slow the query and add a loading screen.
 * @param {string} search_params: Query string containing all the filters
 */
function machRefreshFilteredContent(search_params) {
    let $results_container = jQuery("#filtered-content");

    if ($results_container.length > 0) {
        jQuery.ajax({
            url: backendInfo.ajaxurl + "?" + search_params,
            type: "GET",
            data: {
                action: "mach_filtered_content",
                post_type: jQuery('input[name="filters-post-type"]').val(),
                lang: backendInfo.locale,
            },
            beforeSend: function () {
                machToggleLoadingScreen();
            },
            success: function (result) {
                $results_container.empty();
                $results_container.append(result);

                machToggleLoadingScreen();
                var new_position = jQuery("#filters-anchor").offset();
                var header_height = jQuery(".main-header-fixed").innerHeight();

                if (header_height > 0) {
                    new_position.top -= header_height;
                }

                jQuery("html, body").stop().animate({ scrollTop: new_position.top }, 500);

                machAdjustEmailObfuscation();
            },
        });
    }
}

function machToggleMobileFilters(e) {
    e.preventDefault();
    jQuery(this).toggleClass("opened");
    jQuery(this).parents().find(".filters-wrap").slideToggle(300);
}
